// extracted by mini-css-extract-plugin
export default {"TableBox":"Home_TableBox__I25EQ"};